import { noop } from 'lodash';
import { RevisionActionProps } from 'components/tables/data/revision/types';
import { useApi } from 'api/api-context';
import { showNotification } from '@mantine/notifications';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';
import panic from 'errors/panic';

/**
 * The parameters of the reject action.
 */
export interface ReopenActionParams extends RevisionActionProps {
  reason?: string;
}

/**
 * Implements the reopen action for revision.
 */
export default function useReopenAction() {
  const { getAction } = useApi();

  /**
   * Makes a call to the API to reopen the revision.
   */
  async function reopenRevision({
    revision: { revisionId, revisionName, kind },
    reason,
    onStatusChange = noop,
  }: ReopenActionParams) {
    const revisionResumeWorkAction = getAction('RevisionResumeWork');

    try {
      const { status } = await revisionResumeWorkAction({
        parameters: { revisionId: String(revisionId) },
        payload: { reason },
      });

      onStatusChange({ revisionId, status, reason });

      showNotification({
        title: kind === 'revision' ? 'Revízna správa bola vrátená' : 'Formulár bol vrátený',
        message:
          kind === 'revision'
            ? `Revíznu správu ${revisionName} ste úspešne vrátili.`
            : `Formulár ${revisionName} ste úspešne vrátili.`,
        color: SUCCESS_NOTIFICATION_COLOR,
      });
    } catch (error: any) {
      panic(error);
    }
  }

  return { reopenRevision };
}
